const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`fallback`] = (((context.has(`fallback`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`fallback`) ? context.get(`fallback`) : null), `x`])) : (`x`));
                this.echo(`
`);
                context.proxy[`_dir`] = `@cloudfour/assets/icons/`;
                context.proxy[`_ext`] = `.svg.twig`;
                context.proxy[`_path`] = (((context.has(`_dir`) ? context.get(`_dir`) : null) + (context.has(`name`) ? context.get(`name`) : null)) + (context.has(`_ext`) ? context.get(`_ext`) : null));
                context.proxy[`_fallback_path`] = (((context.has(`_dir`) ? context.get(`_dir`) : null) + (context.has(`fallback`) ? context.get(`fallback`) : null)) + (context.has(`_ext`) ? context.get(`_ext`) : null));
                this.echo(`
`);
                context.proxy[`_class`] = `c-icon`;
                this.echo(`
`);
                if ((context.has(`inline`) ? context.get(`inline`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_class`] = ((context.has(`_class`) ? context.get(`_class`) : null) + ` c-icon--inline`);
                }
                this.echo(`
`);
                if ((context.has(`size`) ? context.get(`size`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_class`] = (((context.has(`_class`) ? context.get(`_class`) : null) + ` c-icon--`) + (context.has(`size`) ? context.get(`size`) : null));
                }
                this.echo(`
`);
                if ((context.has(`muted`) ? context.get(`muted`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_class`] = ((context.has(`_class`) ? context.get(`_class`) : null) + ` c-icon--muted`);
                }
                this.echo(`
`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_class`] = (((context.has(`_class`) ? context.get(`_class`) : null) + ` `) + (context.has(`class`) ? context.get(`class`) : null));
                }
                this.echo(`
`);
                if ((context.has(`title`) ? context.get(`title`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_role`] = ((!!((context.has(`role`)) &&  !this.env.getTest('null').traceableCallable(27, this.source)(...[context.get(`role`)]))) ? (context.get(`role`)) : (`img`));
                    this.echo(`  `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b`, `c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b`, 28, 30), new Map([[`class`, (context.has(`_class`) ? context.get(`_class`) : null)], [`role`, (context.has(`_role`) ? context.get(`_role`) : null)]]), true, false, 28));
                }
                else {
                    this.echo(`  `);
                    context.proxy[`_aria_hidden`] = ((!!((context.has(`aria_hidden`)) &&  !this.env.getTest('null').traceableCallable(37, this.source)(...[context.get(`aria_hidden`)]))) ? (context.get(`aria_hidden`)) : (`true`));
                    this.echo(`  `);
                    this.echo(this.include(context, this.source, new Map([[0, (context.has(`_path`) ? context.get(`_path`) : null)], [1, (context.has(`_fallback_path`) ? context.get(`_fallback_path`) : null)]]), new Map([[`class`, (context.has(`_class`) ? context.get(`_class`) : null)], [`aria_hidden`, (context.has(`_aria_hidden`) ? context.get(`_aria_hidden`) : null)]]), true, false, 38));
                }
            }

            getTemplateName() {
                return `c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b`, ``);
            }
        }],
        [30, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.blocks = new Map([
                    ['before', [this, 'block_before']]
                ]);
            }

            doGetParent(context) {
                return this.loadTemplate(new Map([[0, (context.has(`_path`) ? context.get(`_path`) : null)], [1, (context.has(`_fallback_path`) ? context.get(`_fallback_path`) : null)]]), `c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b`, 28);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.getParent(context).display(context, this.merge(this.blocks, blocks));
            }

            block_before(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      <title>`);
                this.echo(this.env.getFilter('escape').traceableCallable(33, this.source)(...[this.env, (context.has(`title`) ? context.get(`title`) : null), `html`, null, true]));
                this.echo(`</title>
    `);
            }

            getTemplateName() {
                return `c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b');

let template = env.loadTemplate('c5658c9de23405310065ff8f979c332daf807fc867e484ea2947ffae2a8b986b');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/icon/icon.twig", args: context }
     );
     return rendered;;
};